export enum WebSocketMessageType {
  SelectDetectionSetting,
  RunManualDetectionSetting,
  RunManualSortingSetting,
  DetectionResultsReady
}
